import { Injectable } from '@angular/core';
import { UserDto } from '@portal-shared/app/dtos/user.dto';
import { remove, uniqBy } from 'lodash-es';
import { ReplaySubject } from 'rxjs';
import { PortalNotificationClient } from '../handlers/portal-notification-client';

@Injectable({
  providedIn: 'root'
})
export class ConnectedUsersService {
  private connectedUsers: UserDto[] = [];
  private connectedUsers$ = new ReplaySubject<UserDto[]>();

  public constructor(private notificationClient: PortalNotificationClient) {}

  public observeConnectedUsers() {
    return this.connectedUsers$.asObservable();
  }

  private userJoined(userDto: UserDto) {
    this.connectedUsers = uniqBy(this.connectedUsers.concat(userDto), 'email');
    this.connectedUsers$.next(this.connectedUsers);
  }

  private userLeft(userDto: UserDto) {
    remove(this.connectedUsers, connectedUser => connectedUser.email === userDto.email);
    this.connectedUsers$.next(this.connectedUsers);
  }

  public manageNotifications() {
    return [
      this.notificationClient.observeUsersJoined().subscribe(users => {
        users.forEach(u => this.userJoined(u));
      }),
      this.notificationClient.observeUserLeft().subscribe(users => {
        users.forEach(u => this.userLeft(u));
      })
    ];
  }
}
